// extracted by mini-css-extract-plugin
export default {"chartGraph":"styles_chartGraph__fxzOH"};